import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { OfferFragment } from '@occc/graphql';
import { getOfferCustomDataOperation } from '@occc-app/offerHelpers/operations/getOfferCustomDataOperation';

import { getOfferNameAndDescriptionUpdateOperations } from '@occc-app/routes/Offer/components/OfferConfigureForm/utils/offerNameAndDescriptionUpdateOperations';
import { getOfferFulfillmentPriorityUpdateOperations } from '@occc-app/offerHelpers/operations/getOfferFulfillmentPriorityUpdateOperations';
import { ConfigureFormValues } from '../../../types';

type GetConfigureOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: ConfigureFormValues,
  dirtyFields: DirtyFieldsType,
) => Operation[];

export const getConfigureFormOperations: GetConfigureOperations = (
  offerId,
  _,
  values,
  dirtyFields,
) => {
  const additionalOperations: Operation[] = [];

  additionalOperations.push(
    ...getOfferNameAndDescriptionUpdateOperations(offerId, values, dirtyFields),
  );

  additionalOperations.push(
    ...getOfferFulfillmentPriorityUpdateOperations(offerId, values, dirtyFields),
  );

  const customDataOperation = getOfferCustomDataOperation({
    dirtyFields,
    values,
    offerId,
  });
  if (customDataOperation) {
    additionalOperations.push(customDataOperation);
  }

  return [...additionalOperations];
};
